import React from "react";
import { Link } from "react-router";
import ArrowRight from "../assets/img/icon/arrow-right2.svg";


function formatDate(inputDate) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [year, month, day] = inputDate.split("-");
  return `${months[parseInt(month) - 1]} ${parseInt(day)}, ${year}`;
}

const convertBlocksToHtml = (blocks) => {
    // If blocks is not an array, check if it is an object with a "blocks" property.
    if (!Array.isArray(blocks)) {
      if (blocks && Array.isArray(blocks.blocks)) {
        blocks = blocks.blocks;
      } else {
        console.error("Expected an array for blocks, but got:", blocks);
        return "";
      }
    }
    return blocks
      .map((block) => {
        switch (block.type) {
          case "paragraph":
            return `<p>${block.data.text}</p>`;
          case "header":
            return `<h${block.data.level}>${block.data.text}</h${block.data.level}>`;
          case "image":
            return `<img src="${block.data.file.url}" alt="${block.data.caption}" />`;
            case "list":
              const tag = block.data.style === "ordered" ? "ol" : "ul";
              return `<${tag}>${block.data.items
                .map((item) => `<li>${item}</li>`)
                .join("")}</${tag}>`;
          case "quote":
            return `<blockquote>${block.data.text}</blockquote>`;
          case "code":
            return `<pre><code>${block.data.code}</code></pre>`;
          default:
            return "";
        }
      })
      .join("");
  };

  const stripHtml = (html) => {
    // Remove <img> tags completely
    html = html.replace(/<img[^>]*>/g, "");
    html = html.replace(/\[object Object\]/g, "").replace(/\{.*?\}/g, "");

    // Remove all other HTML tags
    return html.replace(/<[^>]*>/g, "");
  };

  const addLineBreaks = (text, charLimit = 50) => {
    return text.replace(/(\S{50,})/g, (match) => {
      return match.replace(new RegExp(`(.{${charLimit}})`, "g"), "$1<br>");
    });
  };

  const truncateText = (text, wordLimit, charLimit = 50) => {
    let plainText = "";
    // If text is a string (e.g. for the title), use it directly.
    if (typeof text === "string") {
      plainText = text;
    } else {
      // Otherwise assume text is an object with a blocks array or is an array already.
      plainText = stripHtml(convertBlocksToHtml(text)).trim();
    }
    let words = plainText.split(/\s+/);
    if (words.length > wordLimit) {
      plainText = words.slice(0, wordLimit).join(" ") + "...";
    }
    return addLineBreaks(plainText, charLimit);
  };


 
const BlogBigCard = ({ blog, comment }) => {
  // Add safety check to prevent errors when blog is undefined
  if (!blog) {
    return null;
  }
  
  return (
    <>
      <article className="single-post-item">
        <div className="post-thumbnail-wrapper">
          <Link to={`/blog/${blog.urlHeading}`}>
            <img src={blog?.homeImage || "https://omsoftwares.in/assets/img/seo/ogImage.png"} alt={blog?.title || "Blog post"} loading="lazy" />
          </Link>
        </div>
        <div className="post-content-wrapper">
          <ul className="post-meta ul_li">
            <li>
              <span>
                <i className="far fa-user"></i>
                <span className="author vcard">{blog.creator === 'creator' || !blog.creator ? 'Admin' : blog.creator}</span>
              </span>
            </li>
            <li>
              <a href={`/blog/${blog.urlHeading}#comments`}>
                <i className="far fa-comments"></i> Comments ({comment})
              </a>
            </li>
            <li>
              <span className="posted-on">
                <i className="far fa-clock"></i> {blog?.date ? (
                   <Link to={`/blog/${blog.urlHeading}`}>{formatDate(blog.date.split("T")[0])}</Link>
                  ) : null}
              </span>
            </li>
          </ul>
          <h3 className="post-title border_effect">
          <Link to={`/blog/${blog.urlHeading}`}>
              {truncateText(blog.title, 15)}
            </Link>
          </h3>
          <div className="post-excerpt">
            <p
            dangerouslySetInnerHTML={{
                __html: blog.excerpt 
                  ? addLineBreaks(blog.excerpt, 50)
                  : blog.content 
                    ? truncateText(blog.content, 25)
                    : "",
              }}
            >
             
            </p>
          </div>
          <div className="post-read-more">
          <Link to={`/blog/${blog.urlHeading}`}
              className="btn-link ul_li"
            >
              Read More{" "}
              <span>
                <img src={ArrowRight} alt="" />
              </span>
            </Link>
          </div>
        </div>
      </article>
    </>
  );
};

export default BlogBigCard;
